export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const SET_THEME = 'SET_THEME'
export const TOGGLE_THEME_MODE = 'TOGGLE_THEME_MODE'